import moment from 'moment'
export default {
  data () {
    return {
      variables: [
        {
          case: '$$ACCESS_TOKEN',
          regx: /\$\$ACCESS_TOKEN/g
        },
        {
          case: '$$HospitalT_ID',
          regx: /\$\$HospitalT_ID/g
        }
      ],
      message: 'Hello World',
      Err: {
        noInPut: 'กรุณากรอกข้อมูล',
        noNull: 'กรุณาเลือกข้อมูล',
        noArray: 'กรุณาเลือกข้อมูล',
        numberOnly: 'กรุณากรอกตัวเลขเท่านั้น',
        noSpace: 'ห้ามมีช่องว่าง',
        phoneNumber: 'กรุณากรอกหมายเลขโทรศัพท์มือถือ 10 หลัก',
        english: 'ภาษาอังกฤษเท่านั้น',
        email: 'รูปแบบอีเมลไม่ถูกต้อง',
        countingNumber: 'กรุณากรอกตัวเลข 1 - 9999',
        noSpecialCharacters: 'ต้องไม่มีอักขระพิเศษ',
        fixCoutingArea: 'กรุณากรอกตัวเลข 1 - 13',
        fixhcode: 'กรุณากรอกตัวเลข 00000-99999'
      },
      Regx: {
        UUID: '',
        CID: '',
        number: /^\d+$/,
        space: /^\S+$/,
        english: /[^A-Za-z0-9@!_.-]/,
        email: /^\S+@\S+\.\S+$/,
        countingNumber: /^(?:[1-9]\d{0,4})$/,
        noSpecialCharacters: /^[^`~!@#$%^&*()_+={}\\|\\:;“’<,>.?๐฿]*$/,
        fixCoutingArea: /^(([1-9])|([1][0-3]{0,1}))$/,
        fixhcode: /^([0-9][0-9][0-9][0-9][0-9])$/
      },
      Rule: {
        noInPut: (v) => this.isEmpty(v) || this.Err.noInPut,
        notNull: (v) => this.isNull(v) || this.Err.noNull,
        noArray: (v) => this.isArray(v) || this.Err.noArray,
        noSpace: (v) => this.isSpace(v) || this.Err.noSpace,
        numberOnly: (v) => this.isNumber(v) || this.Err.numberOnly,
        phoneNumber: (v) => this.isPhoneNumber(v) || this.Err.phoneNumber,
        englishOnly: (v) => this.isEnglish(v) || this.Err.english,
        emailOnly: (v) => this.isEmail(v) || this.Err.email,
        noSpecialCharacters: (v) => this.isNoSpecialCharacters(v) || this.Err.noSpecialCharacters,
        fixCoutingArea: (v) => this.isfixCoutingArea(v) || this.Err.fixCoutingArea,
        fixhcode: (v) => this.fixhcode(v) || this.Err.fixhcode,
        countingNumberOnly: (v) => this.isCountingNumber(v) || this.Err.countingNumber
      },
      gender: [
        { text: 'หญิง', val: 'หญิง' },
        { text: 'ชาย', val: 'ชาย' },
        { text: 'ไม่ระบุ', val: '' }
      ]
    }
  },
  filters: {
    moment: function (date) {
      // return moment(date).format('YYYY/MM/DD HH:mm')
      return moment(date).fromNow(true)
    },
    BE_DD_MM_YYYY: function (date) {
      const x = moment.utc(date).local().add(543, 'year').format('DD-MM-YYYY')
      return x === '' ? null : x
    },

    BE_DD_MM_YYYY_HH_MM: function (date) {
      const x = moment
        .utc(date)
        .local()
        .add(543, 'year')
        .format('DD-MM-YYYY HH:mm')
      return x === '' ? null : x
    },

    BE_DD_MM_YYYY_HH_MM_SS: function (date) {
      const x = moment
        .utc(date)
        .local()
        .add(543, 'year')
        .format('DD-MM-YYYY HH:mm:ss')
      return x === '' ? null : x
    },

    YYYY_MM_DD: function (date) {
      const x = moment(date).format('YYYY-MM-DD')
      return x === '' ? null : x
    },
    YYYY_MM_DD_HH_MM_SS: function (date) {
      const x = moment(date).format('YYYY-MM-DD HH:mm:ss')
      return x === '' ? null : x
    },
    HH_MM_SS: function (date) {
      const x = moment(date).format('HH:mm:ss')
      return x === '' ? null : x
    },
    TextOverFlow: function (data) {
      if (data.length > 3) return data.substring(0, 4) + '...'
      else return data
    },
    FileSize: function (bytes) {
      const decimals = 2
      if (!+bytes) return '0 Bytes'

      const k = 1024
      const dm = decimals < 0 ? 0 : decimals
      const sizes = [
        'Bytes',
        'KiB',
        'MiB',
        'GiB',
        'TiB',
        'PiB',
        'EiB',
        'ZiB',
        'YiB'
      ]

      const i = Math.floor(Math.log(bytes) / Math.log(k))

      return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
    }
  },
  methods: {
    // NOTE Rule function
    isEmpty (str) {
      return !!str
    },
    isNull (str) {
      return str !== null
    },
    isArray (str) {
      return str != null && str.length !== 0
    },
    isSpace (str) {
      return this.Regx.space.test(str)
    },
    isNumber (str) {
      return this.Regx.number.test(str)
    },
    isPhoneNumber (str) {
      return str !== null && (str.length === 10 || str.length === 9)
    },
    isEnglish (str) {
      return !this.Regx.english.test(str)
    },
    isEmail (str) {
      return this.Regx.email.test(str)
    },
    isCountingNumber (str) {
      return this.Regx.countingNumber.test(str)
    },
    isNoSpecialCharacters (str) {
      return this.Regx.noSpecialCharacters.test(str)
    },
    isfixCoutingArea (str) {
      return this.Regx.fixCoutingArea.test(str)
    },
    fixhcode (str) {
      return this.Regx.fixhcode.test(str)
    },
    async checkCaseReplace (url) {
      let URL = url
      if (/\$\$ACCESS_TOKEN/g.test(URL)) {
        const encodedToken = window.btoa(localStorage.getItem('Accesstoken'))
        URL = URL.replaceAll('$$ACCESS_TOKEN', encodedToken)
      }
      if (/\$\$PROJECT_ID/g.test(URL)) {
        URL = URL.replaceAll('$$HospitalT_ID', this.$store.state.HospitalID)
      }
      return URL
    },
    // NOTE Axios Async/Await Fix Try/Catch
    async awaitAxios (options) {
      try {
        const res = await this.axios(options)
        return res.data
      } catch (error) {
        if (error.data !== undefined) return error.data
        else {
          return { code: 400, message: 'Bad Request', data: {}, status: false }
        }
      }
    },
    profileUrl (filename) {
      let url = `${process.env.VUE_APP_API}/api/v1/image/profile/${filename}`
      url += `?accesstoken=${btoa(localStorage.getItem('Accesstoken'))}`
      return url
    },
    imageUrl (filename) {
      let url = `${process.env.VUE_APP_API}/api/v1/image/${filename}`
      url += `?accesstoken=${btoa(localStorage.getItem('Accesstoken'))}`
      return url
    },
    dicomUrl (filename) {
      let url = `${process.env.VUE_APP_API}/api/v1/dicom/${filename}`
      url += `?accesstoken=${btoa(localStorage.getItem('Accesstoken'))}`
      return url
    },
    // LandinfPage
    async sendContact (payload) {
      const data = {
        ...{
          // Edit Constructure here
          email: '',
          first_name: '',
          last_name: '',
          subject: '',
          phone: '',
          description: ''
        },
        ...payload
      }
      // NOTE this function signin
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/contact`,
        method: 'post',
        data: data
      }
      return await this.awaitAxios(options)
    },
    // LandinfPage
    // ResetPasswordMail-----------------------------
    async resetPassword (payload) {
      const data = {
        ...{
          // Edit Constructure here
          password: ''
        },
        ...payload
      }
      // NOTE this function signin
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/user/password/new`,
        method: 'post',
        data: data
      }
      return await this.awaitAxios(options)
    },
    // ResetPasswordMail-----------------------------
    // NOTE User Function --------------------------------
    async sendEmailresetPasswordUser (payload) {
      // NOTE this function sent email for reset passsword
      const data = {
        ...{
          // Edit Constructure here
          email: ''
        },
        ...payload
      }
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/user/password/reset`,
        method: 'post',
        data: data
      }
      return await this.awaitAxios(options)
    },
    async resetPasswordUser (payload) {
      // NOTE this function edit data user
      const data = Object.assign({}, payload)
      delete data.user_id
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/user/${payload.user_id}/password/reset`,
        method: 'post',
        data: data
      }
      return await this.awaitAxios(options)
    },
    async getUserInfo () {
      // NOTE this function get user info
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/user/info`,
        method: 'get'
      }
      return await this.awaitAxios(options)
    },
    async getUserForTable (payload) {
      const params = {
        ...{
          // Edit Constructure here
          page: 1,
          row: 10,
          verify: 0,
          keyword: ''
        },
        ...payload
      }
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/users`,
        method: 'get',
        params: params
      }
      return await this.awaitAxios(options)
    },
    async getUserForDropdownByPermission (payload) {
      const params = Object.assign({}, payload)
      delete params.hospital_id
      params.permission_id = params.permission_id.join()
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/hospital/${payload.hospital_id}/permission/system/users`,
        method: 'get',
        params: params
      }
      return await this.awaitAxios(options)
    },
    async createUser (payload) {
      let data = Object.assign({}, payload)
      data.date_of_birth = this.$moment(payload.date_of_birth)
        .startOf('day')
        .utc()
        .format('YYYY-MM-DD HH:mm:ss')
      data = {
        ...{
          // Edit Constructure here
          // user_id: '',
          first_name: '',
          last_name: '',
          phone: '',
          gender: '',
          name_title: '',
          username: '',
          permissions: [],
          email_verify: '',
          date_of_birth: '',
          street: '',
          zip_code: '',
          city: '',
          country_code: '',
          country: '',
          time_zone: 'UTC',
          // time_zone: this.$moment.tz.guess(),
          description: '',
          // verify: 0,
          image: ''
        },
        ...data
        // ...{ date_of_birth: this.$moment().format('YYYY-MM-DD HH:mm:ss') }
      }
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/user`,
        method: 'post',
        data: data
      }
      return await this.awaitAxios(options)
    },
    async updateUser (payload) {
      // NOTE this function edit data user
      let data = Object.assign({}, payload)
      data.date_of_birth = this.$moment(payload.date_of_birth)
        .startOf('day')
        .utc()
        .format('YYYY-MM-DD HH:mm:ss')
      delete data.user_id
      data = {
        ...{
          // Edit Constructure here
          name_title: '',
          first_name: '',
          last_name: '',
          phone: '',
          gender: '',
          permissions: [],
          date_of_birth: '',
          street: '',
          zip_code: '',
          city: '',
          country_code: '',
          country: '',
          time_zone: 'UTC',
          description: '',
          username: ''
        },
        ...data
      }
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/user/${payload.user_id}`,
        method: 'put',
        data: data
      }
      return await this.awaitAxios(options)
    },
    async deleteUser (payload) {
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/user/${payload.user_id}`,
        method: 'delete'
      }
      return await this.awaitAxios(options)
    },
    async approveUser (payload) {
      // NOTE this function approve or reject user
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/user/${payload.user_id}/${payload.action}`,
        method: 'post'
      }
      return await this.awaitAxios(options)
    },
    async rejectUser () {},
    async restoreUser () {},

    // NOTE Permission Function -------------------------
    async getPermissionForTable (payload) {
      const params = {
        ...{
          // Edit Constructure here
          keyword: '',
          page: 1,
          row: 10
        },
        ...payload
      }
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/permissions`,
        method: 'get',
        params: params
      }
      return await this.awaitAxios(options)
    },
    async getPermissionForDropdown () {
      // NOTE this function get permission dropdown
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/permissions/dropdown`,
        method: 'get'
      }
      return await this.awaitAxios(options)
    },
    async createPermission (payload) {
      let data = Object.assign({}, payload)
      data = {
        ...{
          // Edit Constructure here
          name: '',
          description: '',
          menus: []
        },
        ...data
      }
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/permission`,
        method: 'post',
        data: data
      }
      return await this.awaitAxios(options)
    },
    async updatePermission (payload) {
      let data = Object.assign({}, payload)
      delete data.permission_id
      data = {
        ...{
          // Edit Constructure here
          name: '',
          description: '',
          menus: []
        },
        ...data
      }
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/permission/${payload.permission_id}`,
        method: 'put',
        data: data
      }
      return await this.awaitAxios(options)
    },
    async deletePermission (payload) {
      // NOTE this function delete Permission
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/permission/${payload.permission_id}`,
        method: 'delete'
      }
      return await this.awaitAxios(options)
    },

    // NOTE Menu Function --------------------------------
    async getMenusForNavigation () {
      // NOTE this function get menus for navigation
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/menus/navigation`,
        method: 'get'
      }
      return await this.awaitAxios(options)
    },
    async getMenuForTable (payload) {
      // NOTE this function get items menu for table
      const params = {
        ...{
          // Edit Constructure here
          keyword: '',
          page: 1,
          row: 10
        },
        ...payload
      }
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/menus`,
        method: 'get',
        params: params
      }
      return await this.awaitAxios(options)
    },
    async getMenuForDropdown () {
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/menus/dropdown`,
        method: 'get'
      }
      return await this.awaitAxios(options)
    },
    async createMenu (payload) {
      let data = Object.assign({}, payload)
      data = {
        ...{
          // Edit Constructure here
          text: '',
          name: '',
          path: '',
          icon: '',
          description: ''
        },
        ...data
      }
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/menu`,
        method: 'post',
        data: data
      }
      return await this.awaitAxios(options)
    },
    async updateMenu (payload) {
      let data = Object.assign({}, payload)
      delete data.menu_id
      data = {
        ...{
          // Edit Constructure here
          text: '',
          name: '',
          path: '',
          icon: '',
          description: ''
        },
        ...data
      }
      const options = {
        // url:
        //   this.menu_id === ''
        //     ? `${process.env.VUE_APP_API}/api/v1/menu/${this.editedItem.menu_id}`
        //     : `${process.env.VUE_APP_API}/api/v1/menu/${this.menu_id}/submenu/${this.editedItem.menu_id}`,
        url: `${process.env.VUE_APP_API}/api/v1/menu/${payload.menu_id}`,
        method: 'put',
        data: data
      }
      return await this.awaitAxios(options)
    },
    async deleteMenu (payload) {
      // NOTE this function delete Menu
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/menu/${payload.menu_id}`,
        method: 'delete'
      }
      return await this.awaitAxios(options)
    },

    // NOTE SubMenu --------------------------------------
    async createSubMenu (payload) {
      let data = Object.assign({}, payload)
      delete data.menu_id
      data = {
        ...{
          // Edit Constructure here
          text: '',
          name: '',
          path: '',
          icon: '',
          description: ''
        },
        ...data
      }
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/menu/${payload.menu_id}/submenu`,
        method: 'post',
        data: data
      }
      return await this.awaitAxios(options)
    },
    async updateSubMenu (payload) {
      let data = Object.assign({}, payload)
      delete data.menu_id
      delete data.submenu_id
      data = {
        ...{
          // Edit Constructure here
          text: '',
          name: '',
          path: '',
          icon: '',
          description: ''
        },
        ...data
      }
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/menu/${payload.menu_id}/submenu/${payload.submenu_id}`,
        method: 'put',
        data: data
      }
      return await this.awaitAxios(options)
    },
    async deleteSubMenu (payload) {
      // NOTE this function delete subMenu
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/menu/${payload.menu_id}/submenu/${payload.submenu_id}`,
        method: 'delete'
      }
      return await this.awaitAxios(options)
    },

    // NOTE Service --------------------------------------
    async getServiceForDropdown () {
      // NOTE this function get items servive for select
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/services/dropdown`,
        method: 'get'
      }
      return await this.awaitAxios(options)
    },
    async getServiceForTable (payload) {
      const params = {
        ...{
          // Edit Constructure here
          keyword: '',
          page: 1,
          row: 10
        },
        ...payload
      }
      // NOTE this function get items servive for table
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/services`,
        method: 'get',
        params: params
      }
      return await this.awaitAxios(options)
    },
    async createService (payload) {
      let data = Object.assign({}, payload)
      delete data.service_id
      data = {
        ...{
          // Edit Constructure here
          name: '',
          tag: '',
          description: '',
          type: ''
        },
        ...data
      }
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/service`,
        method: 'post',
        data: data
      }
      return await this.awaitAxios(options)
    },
    async updateService (payload) {
      let data = Object.assign({}, payload)
      delete data.service_id
      data = {
        ...{
          // Edit Constructure here
          name: '',
          tag: '',
          description: ''
        },
        ...data
      }
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/service/${payload.service_id}`,
        method: 'put',
        data: data
      }
      return await this.awaitAxios(options)
    },
    async deleteService (payload) {
      // NOTE this function delete servive
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/service/${payload.service_id}`,
        method: 'delete'
      }
      return await this.awaitAxios(options)
    },

    // NOTE Package --------------------------------------
    async getPackageForDropdown () {
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/packages/dropdown`,
        method: 'get'
      }
      return await this.awaitAxios(options)
    },
    async getPackageForTable (payload) {
      // NOTE this function get data for table
      const params = {
        ...{
          // Edit Constructure here
          keyword: '',
          page: 1,
          row: 10
        },
        ...payload
      }
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/packages`,
        method: 'get',
        params: params
      }
      return await this.awaitAxios(options)
    },
    async createPackage (payload) {
      let data = Object.assign({}, payload)
      delete data.package_id
      data = {
        ...{
          // Edit Constructure here
          name: '',
          limit: 0,
          services: [],
          price: 0,
          description: ''
        },
        ...data
      }
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/package`,
        method: 'post',
        data: data
      }
      return await this.awaitAxios(options)
    },
    async updatePackage (payload) {
      let data = Object.assign({}, payload)
      delete data.package_id
      data = {
        ...{
          // Edit Constructure here
          name: '',
          limit: 0,
          services: [],
          price: 0,
          description: ''
        },
        ...data
      }
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/package/${payload.package_id}`,
        method: 'put',
        data: data
      }
      return await this.awaitAxios(options)
    },
    async deleteItemPackage (payload) {
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/package/${payload.package_id}`,
        method: 'delete'
      }
      return await this.awaitAxios(options)
    },

    // NOTE Hospital -------------------------------------
    async getItemHospitalByToken () {
      // NOTE this function get user info
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/hospitals/dropdown`,
        method: 'get'
      }
      return await this.awaitAxios(options)
    },
    async getHospitalInfo (payload) {
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/hospital/${payload.hospital_id}/info`,
        method: 'get'
      }
      return await this.awaitAxios(options)
    },
    async getHospitalForTable (payload) {
      // NOTE this function get Hospitals pagination
      const params = {
        ...{
          // Edit Constructure here
          keyword: '',
          page: 1,
          row: 10
        },
        ...payload
      }
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/hospitals`,
        method: 'get',
        params: params
      }
      return await this.awaitAxios(options)
    },
    async getHospitalForDropdown () {},
    async createHospital (payload) {
      let data = Object.assign({}, payload)
      delete data.hospital_id
      data = {
        ...{
          // Edit Constructure here
          name: '',
          biz_id: '',
          // phone: '',
          description: '',
          hcode: '',
          province: '',
          district: '',
          area: ''
        },
        ...data
      }
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/hospital`,
        method: 'post',
        data: data
      }
      return await this.awaitAxios(options)
    },
    async updateHospital (payload) {
      let data = Object.assign({}, payload)
      delete data.hospital_id
      data = {
        ...{
          // Edit Constructure here
          name: '',
          biz_id: '',
          // phone: '',
          hcode: '',
          province: '',
          district: '',
          area: '',
          description: ''
        },
        ...data
      }
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/hospital/${payload.hospital_id}`,
        method: 'put',
        data: data
      }
      return await this.awaitAxios(options)
    },
    async deleteHospital (payload) {
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/hospital/${payload.hospital_id}`,
        method: 'delete'
      }
      return await this.awaitAxios(options)
    },
    // menu in hospital-----------------------------------
    async getHospitalMenuForTable (payload) {
      const params = {
        ...{
          // Edit Constructure here
          page: 1,
          row: 99,
          keyword: ''
        },
        ...payload
      }
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/hospital/${payload.hospital_id}/menus`,
        method: 'get',
        params: params
      }
      return await this.awaitAxios(options)
    },
    async getHospitalMenuDropdown (payload) {
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/hospital/${payload.hospital_id}/menus/dropdown`,
        method: 'get'
      }
      return await this.awaitAxios(options)
    },
    async getHospitalMenuFromUser (payload) {
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/hospital/${payload.hospital_id}/user/menu`,
        method: 'get'
      }
      return await this.awaitAxios(options)
    },
    async deleteHospitalMenu (payload) {
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/hospital/${payload.hospital_id}/menu/${payload.menu_id}`,
        method: 'delete'
      }
      return await this.awaitAxios(options)
    },
    async updateHospitalMenu (payload) {
      let data = Object.assign({}, payload)
      delete data.hospital_id
      delete data.menu_id
      data = {
        ...{
          // Edit Constructure here
          text: '',
          name: '',
          path: '',
          icon: '',
          description: '',
          is_iframe: false,
          url: ''
        },
        ...data
      }
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/hospital/${payload.hospital_id}/menu/${payload.menu_id}`,
        method: 'put',
        data: data
      }
      return await this.awaitAxios(options)
    },
    async createHospitalMenu (payload) {
      let data = Object.assign({}, payload)
      delete data.hospital_id
      data = {
        ...{
          // Edit Constructure here
          text: '',
          name: '',
          description: '',
          path: '',
          icon: 'mdi-eye',
          is_iframe: false,
          url: ''
        },
        ...data
      }
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/hospital/${payload.hospital_id}/menu`,
        method: 'post',
        data: data
      }
      return await this.awaitAxios(options)
    },
    // permission in hospital-----------------------------------
    async getHospitalPermissionForTable (payload) {
      const params = {
        ...{
          // Edit Constructure here
          page: 1,
          row: 10,
          keyword: ''
        },
        ...payload
      }
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/hospital/${payload.hospital_id}/permissions`,
        method: 'get',
        params: params
      }
      return await this.awaitAxios(options)
    },
    async getHospitalPermissionForDropdown (payload) {
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/hospital/${payload.hospital_id}/permissions/dropdown`,
        method: 'get',
        params: payload
      }
      return await this.awaitAxios(options)
    },
    async getHospitalPermissionForDropdownEdit (payload) {
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/hospital/${payload.hospital_id}/user/${payload.user_id}/permissions`,
        method: 'get',
        params: payload
      }
      return await this.awaitAxios(options)
    },
    async deleteHospitalPermission (payload) {
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/hospital/${payload.hospital_id}/permission/${payload.permission_id}`,
        method: 'delete'
      }
      return await this.awaitAxios(options)
    },
    async updateHospitalPermission (payload) {
      let data = Object.assign({}, payload)
      delete data.hospital_id
      delete data.permission_id
      data = {
        ...{
          // Edit Constructure here
          name: '',
          description: '',
          menus: [],
          permissions: [],
          tags: []
        },
        ...data
      }
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/hospital/${payload.hospital_id}/permission/${payload.permission_id}`,
        method: 'put',
        data: data
      }
      return await this.awaitAxios(options)
    },
    async createHospitalPermission (payload) {
      let data = Object.assign({}, payload)
      delete data.hospital_id
      data = {
        ...{
          // Edit Constructure here
          name: '',
          menus: [],
          permissions: [],
          description: '',
          tags: []
        },
        ...data
      }
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/hospital/${payload.hospital_id}/permission`,
        method: 'post',
        data: data
      }
      return await this.awaitAxios(options)
    },
    // users in hospital-----------------------------------
    async getHospitalUserForTable (payload) {
      const params = {
        ...{
          // Edit Constructure here
          page: 1,
          row: 10,
          verify: '2',
          keyword: ''
        },
        ...payload
      }
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/hospital/${payload.hospital_id}/users`,
        method: 'get',
        params: params
      }
      return await this.awaitAxios(options)
    },
    async deleteHospitalUser (payload) {
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/hospital/${payload.hospital_id}/user/${payload.user_id}`,
        method: 'delete'
      }
      return await this.awaitAxios(options)
    },
    async updateHospitalUser (payload) {
      let data = Object.assign({}, payload)
      delete data.hospital_id
      delete data.user_id
      data = {
        ...{
          // Edit Constructure here
          permissions: []
        },
        ...data
      }
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/hospital/${payload.hospital_id}/user/${payload.user_id}`,
        method: 'put',
        data: data
      }
      return await this.awaitAxios(options)
    },
    async createHospitalUser (payload) {
      let data = Object.assign({}, payload)
      delete data.hospital_id
      data = {
        ...{
          // Edit Constructure here
          user_id: '',
          permissions: []
        },
        ...data
      }
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/hospital/${payload.hospital_id}/user`,
        method: 'post',
        data: data
      }
      return await this.awaitAxios(options)
    },
    async verifyUserHospital (payload) {
      // NOTE this function approve or reject user in hospital
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/hospital/${payload.hospital_id}/user/${payload.user_id}/${payload.action}`,
        method: 'post'
      }
      return await this.awaitAxios(options)
    },
    async getHospitalPackageForTable (payload) {
      const params = {
        ...{
          // Edit Constructure here
          page: 1,
          row: 10,
          keyword: ''
        },
        ...payload
      }
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/hospital/${payload.hospital_id}/packages`,
        method: 'get',
        params: params
      }
      return await this.awaitAxios(options)
    },
    // package in hospital-----------------------------------
    async createHospitalPackage (payload) {
      let data = Object.assign({}, payload)
      delete data.hospital_id
      delete data.limitPackage
      delete data.duration
      // delete data.limit
      data.start_date = this.$moment(data.start_date)
        .endOf('day')
        .utc()
        .format('YYYY-MM-DD HH:mm:ss')

      data.end_date = this.$moment(data.end_date)
        .endOf('day')
        .utc()
        .format('YYYY-MM-DD HH:mm:ss')
      // data.duration = parseInt(data.duration)
      data = {
        ...{
          // Edit Constructure here
          package_id: '',
          start_date: '',
          end_date: '',
          time_zone: 'UTC',
          description: '',
          quotation: '',
          purchase_order: '',
          invoice: '',
          bill: '',
          receipt: ''
        },
        ...data
      }
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/hospital/${payload.hospital_id}/package`,
        method: 'post',
        data: data
      }
      return await this.awaitAxios(options)
    },
    async updateHospitalPackage (payload) {
      let data = Object.assign({}, payload)
      delete data.hospital_id
      delete data.package_id
      delete data.duration
      // delete data.limit
      data.start_date = this.$moment(data.start_date)
        .endOf('day')
        .utc()
        .format('YYYY-MM-DD HH:mm:ss')
      // data.duration = parseInt(data.duration)
      data.end_date = this.$moment(data.end_date)
        .endOf('day')
        .utc()
        .format('YYYY-MM-DD HH:mm:ss')
      data = {
        ...{
          // Edit Constructure here
          start_date: '',
          end_date: 0,
          time_zone: 'UTC',
          description: '',
          quotation: '',
          purchase_order: '',
          invoice: '',
          bill: '',
          receipt: '',
          limit: 0
        },
        ...data
      }
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/hospital/${payload.hospital_id}/package/${payload.package_id}`,
        method: 'put',
        data: data
      }
      return await this.awaitAxios(options)
    },
    async deleteHospitalPackage (payload) {
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/hospital/${payload.hospital_id}/package/${payload.id}`,
        method: 'delete'
      }
      return await this.awaitAxios(options)
    },

    // history in hospital-----------------------------------
    async getHistoryForTable (payload) {
      const params = {
        ...{
          // Edit Constructure here
          page: 1,
          row: 10,
          keyword: ''
          // diagnosis: '',
          // start_date: '',
          // end_date: '',
          // time_zone: '',
          // series_id: '',
          // type: ''
        },
        ...payload
      }
      const options = {
        url: `${process.env.VUE_APP_API}/api/v2/hospital/${payload.hospital_id}/jobs`,
        method: 'get',
        params: params
      }
      return await this.awaitAxios(options)
    },
    async getHistoryForTableV2 (payload) {
      const params = {
        ...{
          // Edit Constructure here
          page: 1,
          row: 10,
          keyword: '',
          diagnosis: '',
          start_date: '',
          end_date: '',
          time_zone: '',
          series_id: '',
          type: ''
        },
        ...payload
      }
      const options = {
        url: `${process.env.VUE_APP_API}/api/v2/hospital/${payload.hospital_id}/jobs`,
        method: 'get',
        params: params
      }
      return await this.awaitAxios(options)
    },
    async getItemConsult (payload) {
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/hospital/${payload.hospital_id}/users/tag/${payload.tag_name}`,
        method: 'get'
      }
      return await this.awaitAxios(options)
    },
    async getHospitalStatus (payload, status = 'single') {
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/hospital/${payload.hospital_id}/status/${status}`,
        method: 'get'
      }
      return await this.awaitAxios(options)
    },
    async restartProcessAIWithAccesstoken (payload) {
      const data = Object.assign({}, payload)
      // delete data.user_id
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/hospital/${payload.hospital_id}/job/${payload.job_id}/restart`,
        method: 'post',
        data: data
      }
      return await this.awaitAxios(options)
    },

    async updaeteConsult (payload) {
      let data = Object.assign({}, payload)
      delete data.hospital_id
      delete data.job_id
      data = {
        ...{
          // Edit Constructure here
          user_id: []
        },
        ...data
      }
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/hospital/${payload.hospital_id}/job/${payload.job_id}/consult`,
        method: 'put',
        data: data
      }
      return await this.awaitAxios(options)
    },
    async createHistoryReview (payload) {
      let data = Object.assign({}, payload)
      delete data.job_id
      data = {
        ...{
          // Edit Constructure here
          description: ''
        },
        ...data
      }
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/hospital/job/${payload.job_id}/review`,
        method: 'post',
        data: data
      }
      return await this.awaitAxios(options)
    },
    async updaeteHistoryReview (payload) {
      let data = Object.assign({}, payload)
      delete data.job_id
      delete data.review_id
      data = {
        ...{
          // Edit Constructure here
          description: ''
        },
        ...data
      }
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/hospital/job/${payload.job_id}/review/${payload.review_id}`,
        method: 'put',
        data: data
      }
      return await this.awaitAxios(options)
    },
    async exportHistory (payload) {
      const params = {
        ...{
          // Edit Constructure here
          keyword: '',
          diagnosis: '',
          start_date: '',
          end_date: '',
          time_zone: 'UTC',
          service_name: '',
          job_id: ''
        },
        ...payload
      }
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/export/jobs/${payload.hospital_id}`,
        method: 'get',
        params: params,
        responseType: 'blob'
      }

      const res = await this.awaitAxios(options)
      const blob = new Blob([res], { type: 'application/octet-stream' })
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = 'Report_CXR_' + new Date().toLocaleDateString() + '.xlsx'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
    },

    // NOTE Hospital -------------------------------------
    // NOTE signin
    async signIn (payload) {
      // NOTE this function signin
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/signin`,
        method: 'post',
        data: payload
      }
      return await this.awaitAxios(options)
    },
    async GetAESSignature () {
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/signin/signature`,
        method: 'get'
      }
      return await this.awaitAxios(options)
    },
    async getHospitalPackageForUpload (payload) {
      // upload
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/hospital/${payload.hospital_id}/services`,
        method: 'get'
      }
      return await this.awaitAxios(options)
    },
    async signInOneIDAuthorizationCode (payload) {
      // NOTE this function signin
      const p = {
        ...{ authorization_code: '', redirect_url: '' },
        ...payload
      }
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/signin/oneid`,
        method: 'post',
        data: p
      }
      return await this.awaitAxios(options)
    },

    async OauthLogOutOneID () {
      const redirectUri = `${window.location.origin}${process.env.VUE_APP_BASE_URL}login`
      const uri = `${process.env.VUE_APP_ONEID_URL}/api/oauth/logout?redirect_uri=${redirectUri}`
      location.replace(uri)
    },

    // NOTE JOB -----------------------------------------
    async CreateJobForUpload (hospitalId, payload, index) {
      const res = await this.axios.post(
        `${process.env.VUE_APP_API}/api/v1/hospital/${hospitalId}/job`,
        payload,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          onUploadProgress: function (progressEvent) {
            this.items[index].uploadprogress = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            )
          }.bind(this)
        }
      )
      return res

      // const options = {
      //   url: `${process.env.VUE_APP_API}/api/v1/hospital/${hospitalId}/job`,
      //   method: 'post',
      //   headers: { 'Content-Type': 'multipart/form-data' },
      //   body: payload
      // }
      // return await this.awaitAxios(options)
    },

    async CreateMultiJobForUpload (
      hospitalId,
      services = [],
      files = FileList,
      // type = 'single',
      type = '',
      seriesId = '',
      configs = { headers: {} }
    ) {
      // TODO เป็น Function ในการ Upload Job โดยสามารถ Upload image ได้หลายไฟล์
      // TODO โดยจะมี configs เป็นส่วนที่ใช้ในการ passing ส่วนต่างๆเพื่อใช้งานเช่น authorization
      const url = `${process.env.VUE_APP_API}/api/v1/hospital/${hospitalId}/job`

      // const s = services.map((x) => x.service_id)
      // for (const file of files) { // sequential
      files.forEach(async (file) => {
        // parallel
        // TODO สร้าง From data ในการส่ง  file แบบ blob
        const formData = new FormData()

        // TODO สำหรับแพ็ค data ใส่ payload ของ Request
        formData.append('files', file)
        formData.append('services', services.join(','))
        formData.append('type', type)
        if (type === 'series') formData.append('series_id', seriesId)

        const options = {
          url: url,
          method: 'post',
          headers: {
            ...{
              'Content-Type': 'multipart/form-data'
            },
            ...configs.headers
          },
          data: formData,
          onUploadProgress: function (pe) {
            const x = parseInt(Math.round((pe.loaded / pe.total) * 100))
            this.$EventBus.$emit('upload-progress', {
              id: file.id,
              progress: x
            })

            // this.items[index].uploadprogress = parseInt(
            //   Math.round((progressEvent.loaded / progressEvent.total) * 100)
            // )
          }.bind(this)
        }
        await this.awaitAxios(options)
      }) // parallel
      // } // sequential
    },

    async CreateMultiJobForUploadV2 (
      hospitalId,
      services = [],
      files = FileList,
      // type = 'single',
      type = '',
      seriesId = '',
      configs = { headers: {} }
    ) {
      // TODO เป็น Function ในการ Upload Job โดยสามารถ Upload image ได้หลายไฟล์
      // TODO โดยจะมี configs เป็นส่วนที่ใช้ในการ passing ส่วนต่างๆเพื่อใช้งานเช่น authorization
      const url = `${process.env.VUE_APP_API}/api/v2/hospital/${hospitalId}/job`

      // const s = services.map((x) => x.service_id)
      // for (const file of files) { // sequential
      // TODO สร้าง From data ในการส่ง  file แบบ blob
      const formData = new FormData()
      formData.append('services', services.join(','))
      formData.append('type', type)
      files.forEach(async (file) => {
        // TODO สำหรับแพ็ค data ใส่ payload ของ Request
        formData.append('files', file)
      })

      // if (type === 'series') formData.append('series_id', seriesId)

      const options = {
        url: url,
        method: 'post',
        headers: {
          ...{
            'Content-Type': 'multipart/form-data'
          },
          ...configs.headers
        },
        data: formData,
        onUploadProgress: function (pe) {
          const x = parseInt(Math.round((pe.loaded / pe.total) * 100))
          this.$EventBus.$emit('upload-progress', {
            id: 0,
            progress: x
          })

        //   // this.items[index].uploadprogress = parseInt(
        //   //   Math.round((progressEvent.loaded / progressEvent.total) * 100)
        //   // )
        }.bind(this)
      }
      await this.awaitAxios(options)
      // parallel
      // } // sequential
    },

    // NOTE Notification ----------------------------------
    async GetNotifications () {
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/notifications/now`,
        method: 'get'
      }
      return await this.awaitAxios(options)
    },
    async CloseNotification (notificationId = '') {
      if (notificationId.length === 0) {
        return console.warn('not found notification_id')
      }
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/notification/${notificationId}`,
        method: 'delete'
      }
      return await this.awaitAxios(options)
    },
    async ReadNotification (notificationId = '') {
      if (notificationId.length === 0) {
        return console.warn('not found notification_id')
      }
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/notification/${notificationId}/read`,
        method: 'put'
      }
      return await this.awaitAxios(options)
    },

    // NOTE Announcer ----------------------------------
    async getAnnouncerForTable (payload) {
      // NOTE this function get data for table
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/announcers`,
        method: 'get',
        params: payload
      }
      return await this.awaitAxios(options)
    },

    async createAnnounucer (payload) {
      let data = Object.assign({}, payload)
      data.start_date = this.$moment(data.start_date)
        .startOf('day')
        .utc()
        .format('YYYY-MM-DD HH:mm:ss')
      data.end_date = this.$moment(data.end_date)
        .endOf('day')
        .utc()
        .format('YYYY-MM-DD HH:mm:ss')

      data = {
        ...{
          // Edit Constructure here
          announcer_id: '',
          start_date: '',
          end_date: '',
          title: '',
          description: '',
          image: '',
          url: '',
          icon: '',
          type: '',
          time_zone: 'UTC'
        },
        ...data
      }
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/announcer`,
        method: 'post',
        data: data
      }
      return await this.awaitAxios(options)
    },
    async updateAnnouncer (payload) {
      let data = Object.assign({}, payload)
      delete data.announcer_id
      data.start_date = this.$moment(data.start_date)
        .startOf('day')
        .utc()
        .format('YYYY-MM-DD HH:mm:ss')
      data.end_date = this.$moment(data.end_date)
        .endOf('day')
        .utc()
        .format('YYYY-MM-DD HH:mm:ss')

      data = {
        ...{
          // Edit Constructure here
          start_date: '',
          end_date: '',
          title: '',
          description: '',
          image: '',
          url: '',
          icon: '',
          type: '',
          time_zone: 'UTC'
        },
        ...data
      }
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/announcer/${payload.announcer_id}`,
        method: 'put',
        data: data
      }
      return await this.awaitAxios(options)
    },
    async deleteItemAnnouncer (payload) {
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/announcer/${payload.announcer_id}`,
        method: 'delete'
      }
      return await this.awaitAxios(options)
    },

    async getAnnouncerToday () {
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/announcers/today`,
        method: 'get'
      }
      return await this.awaitAxios(options)
    },
    // NOTE PRofile ------------------------------------
    async getProfile () {
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/profile`,
        method: 'get'
      }
      return await this.awaitAxios(options)
    },
    async updateProfile (payload) {
      let data = Object.assign({}, payload)
      data.date_of_birth = this.$moment(data.date_of_birth)
        .startOf('day')
        .utc()
        .format('YYYY-MM-DD HH:mm:ss')

      data = {
        ...{
          // Edit Constructure here
          first_name: '',
          last_name: '',
          phone: '',
          gender: '',
          date_of_birth: '',
          name_title: '',
          street: '',
          zip_code: '',
          city: '',
          country_code: '',
          country: '',
          time_zone: 'UTC',
          description: '',
          email: ''
        },
        ...data
      }
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/profile`,
        method: 'put',
        data: data
      }
      return await this.awaitAxios(options)
    },
    async UploadProfileImage (payload) {
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/profile/image`,
        method: 'put',
        // maxContentLength: Infinity,
        maxBodyLength: Infinity,
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        data: payload
      }
      return await this.awaitAxios(options)
    },

    async ConnectOneIDAccount (payload) {
      const p = {
        ...{ authorization_code: '', redirect_uri: '' },
        ...payload
      }
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/profile/connect/oneid`,
        method: 'post',
        data: p
      }
      return await this.awaitAxios(options)
    },
    async ConnectProviderIDAccount (payload) {
      const p = {
        ...{ authorization_code: '', redirect_uri: '' },
        ...payload
      }
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/profile/connect/providerid`,
        method: 'post',
        data: p
      }
      return await this.awaitAxios(options)
    },
    // NOTE Page Notification ------------------------------------
    async getNotificationForTable (payload) {
      // DTO
      const p = {
        ...{
          page: 1,
          row: 10,
          keyword: '',
          read: ''
        },
        ...payload
      }
      // NOTE this function get data for table
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/notifications`,
        method: 'get',
        params: p
      }
      return await this.awaitAxios(options)
    },
    async sendCmdNotification (payload) {
      const p = {
        ...{
          notification_id: '',
          command: ''
        },
        ...payload
      }
      // NOTE this function get data for table
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/notification/${p.notification_id}/cmd/${p.command}`,
        method: 'put'
      }
      return await this.awaitAxios(options)
    },
    async deleteItemNotification (payload) {
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/notification/${payload.notification_id}`,
        method: 'delete'
      }
      return await this.awaitAxios(options)
    },
    // NOTE Page Task ------------------------------------
    async getTaskForTable (payload) {
      const params = {
        ...{
          // Edit Constructure here
          hospital_id: '',
          page: 1,
          row: 10,
          keyword: '',
          diagnosis: ''
        },
        ...payload
      }
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/tasks`,
        method: 'get',
        params: params
      }
      return await this.awaitAxios(options)
    },
    // NOTE HOSPITAL API KEY --------------------------------
    async getHostitalApiKeyTable (hospitalId, payload) {
      // TODO สำหรับดึงข้อมูล API KEY
      const params = {
        ...{
          // Edit Constructure here
          page: 1,
          row: 10,
          keyword: ''
        },
        ...payload
      }
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/hospital/${hospitalId}/apikeys`,
        method: 'get',
        params: params
      }
      return await this.awaitAxios(options)
    },
    async createHostitalApiKey (hospitalId, payload) {
      // TODO สำหรับเพิ่ม API KEY
      const p = {
        ...{
          // Edit Constructure here
          name: '',
          description: '',
          allows: ''
        },
        ...payload
      }
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/hospital/${hospitalId}/apikey`,
        method: 'post',
        data: p
      }
      return await this.awaitAxios(options)
    },
    async updateHostitalApiKey (hospitalId, apikeyId, payload) {
      // TODO สำหรับเพิ่ม API KEY
      const p = {
        ...{
          // Edit Constructure here
          name: '',
          description: '',
          allows: ''
        },
        ...payload
      }
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/hospital/${hospitalId}/apikey/${apikeyId}`,
        method: 'put',
        data: p
      }
      return await this.awaitAxios(options)
    },
    async deleteHostitalApiKey (payload) {
      const p = {
        ...{ hospital_id: '', apikey_id: '' },
        ...payload
      }
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/hospital/${p.hospital_id}/apikey/${p.apikey_id}`,
        method: 'delete'
      }
      return await this.awaitAxios(options)
    },
    // NOTE COMMENT ---------------------------------------
    async CreateJobComment (payload) {
      // TODO เป็น Function สำหรับ Create Job Comment
      const p = {
        ...{
          user_id: '',
          type: '',
          message: '',
          image: '',
          sticker: '',
          comments: [],
          agrees: []
        },
        ...payload
      }
      delete p.hospital_id
      delete p.job_id

      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/hospital/${payload.hospital_id}/job/${payload.job_id}/comment`,
        method: 'post',
        data: p
      }
      return await this.awaitAxios(options)
    },
    async UpdateJobComment (payload) {
      // TODO เป็น Function สำหรับ Update Job Comment
      const p = {
        ...{
          user_id: '',
          type: '',
          message: '',
          image: '',
          sticker: '',
          comments: [],
          agrees: []
        },
        ...payload
      }
      delete p.hospital_id
      delete p.job_id
      delete p.comment_id

      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/hospital/${payload.hospital_id}/job/${payload.job_id}/comment/${payload.comment_id}`,
        method: 'put',
        data: p
      }
      return await this.awaitAxios(options)
    },
    async DeleteJobComment (payload) {
      // TODO เป็น Function สำหรับ Delete Job Comment
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/hospital/${payload.hospital_id}/job/${payload.job_id}/comment/${payload.comment_id}`,
        method: 'delete'
      }
      return await this.awaitAxios(options)
    },
    // NOTE Utils Function
    isUUID (str) {
      return /^$|^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/.test(str)
    },

    // NOTE REST Function
    async GetVersion () {
      // NOTE เป็น Function ที่ใช้ในการ Get Version ที่กำลังมีการใช้งานระบบ
      console.log('1.0.0')
    },

    async GetOneIdFromCid (sender_cid = '', receiver_cid = '') {
      // NOTE เป็น Function ที่ใช้ในการขอ OneID ของ Sender และ Receiver(to) จาก CID
      try {
        const options = {
          url: 'https://meet.manageai.co.th/api/v1/getoneid',
          method: 'post',
          data: {
            sender_cid: sender_cid,
            receiver_cid: receiver_cid
          }
        }
        const res = await this.axios(options)
        if (res.data.status) {
          // Data Tranfer Object to Output Function
          return {
            sender_oneid: res.data.data.sender,
            receiver_oneid: res.data.data.to
          }
        } else throw new Error(res.data.message)
      } catch (error) {
        throw new Error(error.message)
      }
    },

    async GetAgoraCredential (data) {
      // NOTE เป็น Function ที่ใช้ในการขอ Agora Credential สำหรับการสนทนากับ Application
      try {
        // data tranfer object
        const payload = {
          ...{
            sender_cid: '',
            sender_oneid: '',
            receiver_cid: '',
            receiver_oneid: '',
            display_name: '',
            his_id: '',
            biz_id: '',
            secret_key: '',
            option: '',
            app_receiver: '',
            ref1: '',
            ref2: '',
            ref3: ''
          },
          ...data
        }
        const options = {
          method: 'post',
          url: 'https://meet.manageai.co.th/api/v2/conference/token',
          data: {
            sender_cid: payload.sender_cid,
            sender: payload.sender_oneid,
            to_cid: payload.receiver_cid,
            to: payload.receiver_oneid,
            display_name: payload.display_name,
            option: payload.option,
            his_id: payload.his_id,
            biz_id: payload.biz_id,
            secret_key: payload.secret_key,
            app_receiver: payload.app_receiver,
            ref1: payload.ref1,
            ref2: payload.ref2,
            ref3: payload.ref3
          }
        }
        const res = await this.axios(options)
        if (res.data.status) {
          return {
            appid: res.data.data.app_id,
            token: res.data.data.agora_token,
            channel: res.data.data.channel_name,
            features: res.data.data.features
          }
        } else throw new Error(res.data.message)
      } catch (error) {
        throw new Error(error.message)
      }
    },

    async GetAgoraCredentialFromRoomId (data) {
      // NOTE สำหรับดึงข้อมูล Agora Credential โดยใช้ room id ที่ทาง Backend Generate link
      // NOTE ตามที่ได้คุยกัน 2023-03-05 20:07
      try {
        // data tranfer object
        const payload = {
          ...{
            room_id: ''
          },
          ...data
        }
        const options = {
          method: 'post',
          url: 'https://meet.manageai.co.th/api/v1/room/start',
          data: { room_id: payload.room_id }
        }
        const res = await this.axios(options)
        if (res.data.status) {
          console.log(res.data.data.room_detail.redirect_url)
          return {
            appid: res.data.data.app_id,
            token: res.data.data.agora_token,
            channel: res.data.data.channel_name,
            features: res.data.data.features,
            sender: res.data.data.room_detail.sender,
            redirect: res.data.data.room_detail.redirect_url
          }
        } else throw new Error(res.data.message)
      } catch (error) {
        throw new Error(error.message)
      }
    },

    async GetAgoraCredentialGroup2 (channel = '') {
      // NOTE เป็น Function ที่ใช้ในการขอ Agora Credential สำหรับการสนทนาแบบกลุ่ม
      try {
        if (await this.isUUID(channel)) {
          const options = {
            url: 'https://meet.manageai.co.th/api/v1/meet/create',
            method: 'post',
            data: { channel_name: channel }
          }
          const res = await this.axios(options)
          if (res.data.status) {
            // Data Tranfer Object to Output Function
            return {
              token: res.data.data.token,
              appid: res.data.data.appid,
              channel: res.data.data.channel_name,
              uid: res.data.data.uid,
              features: res.data.data.features
            }
          } else throw new Error(res.data.message)
        } else {
          throw new Error(this.Err.ChannelIncorrectFormat)
        }
      } catch (error) {
        throw new Error(error.message)
      }
    },
    async GetAgoraCredentialGroup (payload) {
      let data = Object.assign({}, payload)
      data = {
        ...{
          // Edit Constructure here
          channel_name: payload.channel
        },
        ...data
      }
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/conference/room/create`,
        method: 'post',
        data: data
      }
      return await this.awaitAxios(options)
    },
    async GetUserOnline (payload) {
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/users/online`,
        method: 'get'
      }
      return await this.awaitAxios(options)
    },
    // Alert to Client
    async AlertToClient (payload) {
      // let data = Object.assign({}, payload)
      const data = {
        ...{
          // Edit Constructure here
          user_ids: payload
        }
      }
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/conference/alert`,
        method: 'post',
        data: data
      }
      return await this.awaitAxios(options)
    },
    async GetAgoraCredentialGroupForJoinRoom (payload) {
      let data = Object.assign({}, payload)
      data = {
        ...{
          // Edit Constructure here
          channel_name: payload.channel
        },
        ...data
      }
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/conference/room/join`,
        method: 'post',
        data: data
      }
      return await this.awaitAxios(options)
    },
    async AgoraStartRecord (channel = '') {
      // NOTE เป็น Function ที่ใช้ในการเริ่มต้นการอัดการสนทนา
      try {
        console.log('AGORA : start record :', channel)
        const options = {
          url: 'https://meet.manageai.co.th/api/v1/record/start',
          method: 'post',
          data: {
            channel_name: channel
          }
        }
        const res = await this.axios(options)
        if (res.data.status) {
          // Data Tranfer Object to Output Function
          return { message: res.data.message }
        } else throw new Error(res.data.message)
      } catch (error) {
        throw new Error(error.message)
      }
    },

    async AgoraStopRecord (channel = '') {
      // NOTE เป็น Function ที่ใช้ในการสิ้นสุดการอัดการสนทนา
      try {
        console.log(`AGORA : stop record : ${channel}`)
        const options = {
          url: 'https://meet.manageai.co.th/api/v1/record/stop',
          method: 'post',
          data: {
            channel_name: channel
            // webhook: webhook,
          }
        }
        const res = await this.axios(options)
        if (res.data.status) {
          // Data Tranfer Object to Output Function
          return { message: res.data.message }
        } else throw new Error(res.data.message)
      } catch (error) {
        throw new Error(error.message)
      }
    },

    async AgoraEndingCalling (channel = '') {
      try {
        const options = {
          url: 'https://meet.manageai.co.th/api/v1/calling/ending',
          method: 'post',
          data: {
            channel_name: channel
            // webhook: webhook,
          }
        }
        const res = await this.axios(options)
        if (res.data.status) {
          // Data Tranfer Object to Output Function
          return { message: res.data.message }
        } else throw new Error(res.data.message)
      } catch (error) {
        throw new Error(error.message)
      }
    }
  }
}
